/* istanbul ignore file */
import uuidV4 from 'uuid/v4';

const createDocUpload = (dispatch, data, docUploadUrl) => fetch(`${docUploadUrl}/servicing/v1/communications/docs`, {
  credentials: 'include',
  method: 'POST',
  body: data,
  headers: {
    'icaas-correlation-id': uuidV4(),
  },
}).then(
  (response) => response
).then(
  (res) => res.json()
);
export default createDocUpload;
